import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-mb-1 tw-block tw-text-xs dark:tw-text-white"
}
const _hoisted_2 = ["id", "name", "data-testid", "value", "min", "max", "required", "disabled", "title", "list"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 1,
  class: "tw-mt-1 tw-text-2xs tw-text-red-700"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({
        'tw-w-full tw-rounded-md tw-border tw-bg-white hover:tw-border-deep-orange-500 dark:tw-bg-black dark:tw-text-white': true,
        'focus-within:tw-border-transparent focus-within:tw-ring-2 focus-within:tw-ring-deep-orange-500 hover:focus-within:tw-border-transparent':
          !_ctx.disabled && !_ctx.error,
        'tw-cursor-not-allowed tw-border-gray-300 tw-bg-gray-100 tw-text-gray-500 dark:tw-border-gray-700 dark:tw-bg-gray-800 dark:tw-text-gray-400':
          _ctx.disabled,
        'tw-border-red-300 dark:tw-border-red-700': _ctx.error
      })
    }, [
      _createElementVNode("input", {
        id: _ctx.id || _ctx.labelBasedId,
        ref: "input",
        type: "time",
        name: _ctx.id || _ctx.labelBasedId,
        "data-testid": _ctx.id || _ctx.labelBasedId,
        class: _normalizeClass({
          'time-picker': true,
          'tw-w-full tw-rounded-md tw-bg-white tw-p-2 tw-text-sm tw-outline-none focus:tw-outline-none focus:tw-ring-0 dark:tw-bg-black': true
        }),
        value: _ctx.timeSelected,
        min: _ctx.min,
        max: _ctx.max,
        required: _ctx.required,
        disabled: _ctx.disabled,
        title: _ctx.getTitle,
        list: `time_list_${_ctx.id || _ctx.labelBasedId}`,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
        onDblclick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.forceShowPicker && _ctx.forceShowPicker(...args)))
      }, null, 40, _hoisted_2),
      _createElementVNode("datalist", {
        id: `time_list_${_ctx.id || _ctx.labelBasedId}`
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeList, (time) => {
          return (_openBlock(), _createElementBlock("option", {
            key: time,
            value: time
          }, null, 8, _hoisted_4))
        }), 128))
      ], 8, _hoisted_3)
    ], 2),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}